import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {Router } from '@angular/router';
import { AuthServiceService } from 'app/Authentification/auth-service.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { ReleaseVersionService } from 'app/Shared/Services/release-version.service';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { first } from 'rxjs';
@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    imports: [ReactiveFormsModule,CommonModule, ButtonModule,ToastModule,MatCardModule, 
      FormsModule,MatFormFieldModule, MatInputModule, ],
    providers: []
})
export class ForgotPasswordComponent implements OnInit {
  error: string="";
  loading: any;
  userForm!: FormGroup;
  resetForm!: FormGroup;
  showNewPassword=false;
  step = 1;
  username="";
  

  constructor(private router: Router,
    private fb: FormBuilder,
    public authenticationService: AuthServiceService,
    private releaseVersionService: ReleaseVersionService,
    private messageService: MessageService,
    private constantService:ConstantService

  ) {
      this.userForm = this.fb.group(
        {
          username: [
            '',Validators.required]
        }
      );
      this.resetForm = this.fb.group({
        code: ['', Validators.required,Validators.minLength(6)],
        newPassword: ['', [Validators.pattern(ConstantService.passwordRegex),]],
      });
      this.step = 1;
      this.userForm.reset();
   }

     toggleNewPassword() {
    this.showNewPassword = !this.showNewPassword;
  }


  sendOtp() {
    this.error = "";

    if (!this.loading) {
      this.username = this.userForm.get('username')?.value;
      let payload = {
        "username": this.username
      }
      this.loading = true;

      this.authenticationService.forgotPassword(payload)
        .pipe(first())
        .subscribe({
          next: (result: any) => {
            this.loading = false;
            if (result?.success === true) {

              if (result?.success) {
                this.step= 2;
                this.messageService.add({ severity: 'success', summary: 'Success Message', detail:"If this account exists, an OTP has been sent." });
              } else {
                this.error = "Failed to reset new password.";
              }

            } else {
              this.error = (result?.error || 'Unknown error');
            }
          },

          error: (err: HttpErrorResponse) => {
            this.loading = false;
            if (err.status === 400) {
              this.error = "Something went wrong, please try after some time..";
            } else if (err.status === 401) {
              this.error = "Session expired. Please try again.";
            } else {
              this.error = err?.error?.message || "Something went wrong.";
            }
            this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: this.error });
          }
        });
    }
  }

  resetPassword() {
    this.error = "";
    const username =this.username;
    const code = this.resetForm.get('code')?.value;
    const newPassword = this.resetForm.get('newPassword')?.value;
    if (!this.loading) {
      let payload = {
        "username": username?.trim(),
        "code":String(code),
        "newPassword":newPassword?.trim(),
        "uiVersion":this.releaseVersionService.getReleaseVersion()
      }
      this.loading = true;

      this.authenticationService.confirmPassword(payload)
        .pipe(first())
        .subscribe({
          next: (result: any) => {
            this.loading = false;
            if (result?.success === true) {

              if (result?.success) {
                this.step= 1;
                this.messageService.add({ severity: 'success', summary: 'Success Message', detail:"Password reset successful." });
              } else {
                this.error = "Failed to reset new password.";
              }

            } else {
              this.error = 'Authentication: ' + (result?.error || 'Unknown error');
            }
          },

          error: (err: HttpErrorResponse) => {
            this.loading = false;
            if (err.status === 400) {
              this.error = "Invalid User Name and OTP.";
            } else if (err.status === 401) {
              this.error = "OTP expired. Please try again.";
            } else {
              this.error = err?.error?.message || "Something went wrong.";
            }
            this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: this.error });
          }
        });
    }
  }
  
  public routeToLogin(url: string) {
		this.router.navigate(["/login"]);
	}
  public ngOnInit() {
  }

}
